import { render, staticRenderFns } from "./testQuestions.vue?vue&type=template&id=88024d32&scoped=true"
import script from "./testQuestions.vue?vue&type=script&lang=js"
export * from "./testQuestions.vue?vue&type=script&lang=js"
import style0 from "./testQuestions.vue?vue&type=style&index=0&id=88024d32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88024d32",
  null
  
)

export default component.exports